export enum UserRoleBadgeEnum {
    INSIDER = "insider",
    MODERATOR = "moderator",
    SUPPORT = "support",
    ANBIETER = "anbieter",
    TEST = "test",
    AMBASSADOR = "ambassador",
    DEFAULT = "default",
}

export enum USER_GENDERS {
    MALE = "male",
    FEMALE = "female",
}
